<template>
  <div class="message">
    <!-- 搜索 -->
    <sirui-search
      ref="siruiSearch"
      :query="query"
      :columns="searchColumns"
      @resetBtnClick="resetBtnClick"
      @searchBtnClick="searchBtnClick"
      @customerChange="customerChange"
      @orderChange="orderChange"
    >
    </sirui-search>
    <!-- 表格 -->
    <div class="main-content">
      <vxe-toolbar v-if="menuButtonList && menuButtonList.length > 0">
        <template v-slot:buttons>
          <template v-for="item in menuButtonList">
            <vxe-button
              type="primary"
              :icon="item.attributes.buttonStyle"
              :style="
                'background-color:' +
                (item.label == '删除' || item.label == '禁用' ? '#FE8783' : 'rgb(98, 153, 254)') +
                ';border:1px solid ' +
                (item.label == '删除' || item.label == '禁用' ? '#FE8783' : 'rgb(98, 153, 254)')
              "
              :key="item.id"
              @click="chooseClick(item.attributes.buttonUrl, item)"
              >{{ item.label }}</vxe-button
            >
          </template>
        </template>
      </vxe-toolbar>
      <vxe-grid
        border
        show-overflow
        resizable
        ref="table"
        class="vxe-table-element"
        size="mini"
        align="left"
        :auto-resize="true"
        :reserve="true"
        :data="tableData"
        :columns="columnList"
        :checkbox-config="{ reserve: reserve }"
        row-id="id"
        :loading="load"
        show-footer
        :max-height="$store.state.app.tableHeight"
        :footer-method="footerMethod"
        highlight-current-row
        column-min-width="120"
      >
      </vxe-grid>
      <!-- 分页 -->
      <div class="pagination">
        <el-pagination
          ref="page"
          background
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="page.pageNum"
          :page-sizes="[10, 20, 50, 100]"
          :page-count="page.pages"
          :page-size="page.pageSize"
          :total="page.total"
          layout="total, sizes, prev, pager, next, jumper"
        ></el-pagination>
      </div>
    </div>
    <!-- 批量认领 -->
    <set-stop-interest-date ref="setStopInterestDate"></set-stop-interest-date>
  </div>
</template>

<script>
  import SiruiSearch from '@/components/SiruiSearch';
  import API from '@/api/capitalCenter/moneyDraw';
  import { mapState } from 'vuex';
  import SetStopInterestDate from './setStopInterestDate';
  import XEUtils from 'xe-utils';
  import baseUrl from '@/common/config';
  // import LinkDialog from '@/pages/capitalCenter/moneyDraw/interestDailyReport/linkDialog.vue';
  export default {
    name: 'interestDetailReportHN',
    components: {
      SiruiSearch,
      SetStopInterestDate,
      // LinkDialog,
    },
    computed: {
      ...mapState({
        userInfo: (state) => state.userInfo,
        refreshList: (state) => state.tagsView.refreshList,
      }),
      token() {
        return {
          access_token: this.userInfo.userInfo.access_token,
          companyCode: this.userInfo.userInfo.companyCode,
          companyName: this.userInfo.userInfo.companyName,
          departmentCode: this.userInfo.userInfo.departmentCode,
          departmentName: this.userInfo.userInfo.departmentName,
          tenantCode: this.userInfo.userInfo.tenantCode,
        };
      },
      searchColumns() {
        return [
          {
            name: '客户',
            prop: 'customerCode',
            type: 'searchTableSpec',
            searchType: 'partner',
            isMultiple: true,
            currentValue: this.query.customerName,
            changeMethod: 'customerChange',
            extraData: {
              companyCode: this.$globalVar.subserver.companyCode,
            },
          },
          {
            name: '日期从',
            prop: 'interestDateStart',
            type: 'startDaterangePicker',
          },
          {
            name: '日期到',
            prop: 'interestDateEnd',
            type: 'endDaterangePicker',
          },
          {
            name: '订单',
            prop: 'orderNo',
            type: 'searchTableSpec',
            searchType: 'hnOrder',
            extraData: { customerNo: this.query.customerCode },
            isMultiple: true,
            currentValue: this.query.orderNo,
            changeMethod: 'orderChange',
          },
          {
            name: '停止计息日期',
            prop: 'stopInterestDate',
            type: 'input',
            disabled: true,
          },
        ];
      },
      columnList() {
        return [
          {
            field: 'interestDate',
            title: '日期',
          },
          {
            field: 'orderNo',
            title: '订单',
          },
          {
            field: 'customerName',
            title: '客户',
          },
          {
            field: 'orderPaymentAmount',
            title: '本日订单发生额',
            slots: {
              default: ({ row }) => {
                return [
                  <link-dialog
                    propName={row.orderPaymentAmount}
                    interType="HN"
                    query={{
                      orderCompanyCode: row.orderCompanyCode,
                      orderDepartmentCode: row.orderDepartmentCode,
                      interestDate: row.interestDate,
                    }}
                  ></link-dialog>,
                ];
              },
            },
          },
          {
            field: 'orderReceiptAmount',
            title: '本日订单收款额',
            slots: {
              default: ({ row }) => {
                return [
                  <link-dialog
                    propName={row.orderReceiptAmount}
                    interType="HN"
                    query={{
                      orderCompanyCode: row.orderCompanyCode,
                      orderDepartmentCode: row.orderDepartmentCode,
                      interestDate: row.interestDate,
                    }}
                  ></link-dialog>,
                ];
              },
            },
          },
          {
            field: 'orderOccupancyAmount',
            title: '计息金额',
          },
          {
            field: 'orderInterestAmount',
            title: '利息',
          },
        ];
      },
    },
    data() {
      return {
        query: {
          customerCode: null,
          customerName: null,
          interestDateStart: null,
          interestDateEnd: null,
          orderNo: null,
          stopInterestDate: null,
        },
        page: {
          pages: 0,
          pageSize: 10,
          pageNum: 1,
          total: 0,
        },
        load: false,
        tableData: [],
        menuButtonList: [],
        reserve: true,
      };
    },
    mounted() {
      this.getButtonList();
    },
    methods: {
      async getData() {
        if (!this.query.customerName || !this.query.orderNo) {
          return this.$message({
            showClose: true,
            message: '请输入客户和订单查询条件！',
            type: 'error',
          });
        }
        this.load = true;
        const { pageNum, pageSize } = this.page;
        const params = { ...this.query, pageNum, pageSize };
        let res = await this.$axios.post(API.QUERY_INTERESTDETAILREPORTHN_PAGE, params);
        if (res) {
          this.load = false;
          if (res.data.code === 0) {
            this.tableData = res.data.data.records;
            this.page.total = res.data.data.total;
          } else {
            this.$alert(res.data.msg);
          }
        }
      },
      customerChange(val) {
        let item = val.val;
        if (item && item.length > 0) {
          this.query.customerCode = item[0].partnerCode;
          this.query.customerName = item[0].partnerZhName;
        } else {
          this.query.customerCode = this.query.customerName = null;
        }
      },
      orderChange(val) {
        let item = val.val;
        if (item && item.length > 0) {
          this.query.orderNo = item[0].contractNo;
        } else {
          this.query.orderNo = null;
        }
      },
      footerMethod({ columns, data }) {
        let returnProps = ['orderInterestAmount'];
        return [
          columns.map((column, columnIndex) => {
            if (columnIndex === 0) {
              return '合计';
            }
            if (returnProps.includes(column.property)) {
              return XEUtils.toFixedNumber(XEUtils.calSum(data, column.property), 2);
            }
            return null;
          }),
        ];
      },
      //获取菜单按钮
      getButtonList() {
        this.getButtons().then((res) => {
          this.menuButtonList = res;
        });
      },
      // 搜索
      searchBtnClick() {
        this.resetBtnClick();
      },
      // 重置
      resetBtnClick() {
        this.page.pages = 0;
        this.page.pageSize = 10;
        this.page.pageNum = 1;
        this.page.total = 0;
        this.getData();
      },
      handleSizeChange(value) {
        this.page.pageSize = value;
        this.getData();
      },
      handleCurrentChange(value) {
        this.page.pageNum = value;
        this.getData();
      },
      chooseClick(value) {
        if (value == 'setStopInterestDate') {
          this.setStopInterestDate();
        } else if (value == 'export') {
          this.export();
        }
      },

      // 导出
      export() {
        if (!this.query.customerName || !this.query.orderNo) {
          return this.$message({
            showClose: true,
            message: '请输入客户和订单查询条件！',
            type: 'error',
          });
        }
        if (this.tableData.length == 0) {
          return this.$message({
            showClose: true,
            message: this.$t('message.noExport'),
            type: 'error',
          });
        }
        let query = this.filterEmpty(this.query);
        Object.keys(query).forEach((value) => {
          if (XEUtils.isArray(query[value])) {
            query[value + 'Str'] = query[value].join(',');
            delete query[value];
          }
        });
        const params = XEUtils.serialize(query);
        window.location.href = `${baseUrl}${API.EXPORT_INTERSET_DETAIL}?${params}&access_token=${this.token.access_token}`;
      },
      setStopInterestDate() {
        if (!this.query.customerCode || !this.query.orderNo) {
          return this.$message({
            showClose: true,
            message: '请输入客户和订单查询条件！',
            type: 'error',
          });
        }
        this.$refs.setStopInterestDate.openDialog({
          customerCode: this.query.customerCode,
          customerName: this.query.customerName,
          orderNo: this.query.orderNo,
        });
      },
    },
  };
</script>
